// WHERE THE ENGINE'S PLANE SITS, in world units in front of the backdrop.
//
// Not zero, deliberately. The dot-grid ground is at z = 0, and the engine
// needs clear air both behind it and in front so the flow ribbons can be
// authored either side -- one diving behind the block and coming back out
// in front is the whole 3D read.
//
// Whatever this is, code placing the group must take the frustum at THIS
// depth (`viewport.getCurrentViewport(camera, ...)`) rather than the z = 0
// `viewport.width`, which is about 2.5% wider here.
export const ENGINE_PLANE_Z = 0.15;

// THE STACKING ORDER INSIDE THE ENGINE'S GROUP, and it IS the depth.
//
// Everything in the stage is coplanar and none of it writes or tests
// depth, so what is in front of what is decided entirely here.
//
// Painter's order, back to front:
//   aura       -- the engine's own glow, furthest back
//   linesBack  -- anything that passes BEHIND the engine; the airflow
//   plate      -- the engine artwork itself
//
// `linesFront` and `guides` are gone with the spark lines that were the
// only things using them. The gaps of 10 remain on purpose, so a front
// pass can be slotted back in above `plate` without renumbering.
export const ENGINE_STAGE_RENDER_ORDER = {
  aura: 10,
  linesBack: 20,
  plate: 30,
} as const;
